import { Routes, Route, Navigate } from "react-router-dom";

import Header from "@/components/header";
import useStore from "@/services/store";

import ChatList from "./ChatList";
import ChatConversation from "./ChatConversation";

function ChatLayout() {
  return (
    <div className="h-[calc(100vh-4rem)] flex gap-6 p-6 overflow-hidden">
      <div className="hidden md:block w-80 shrink-0">
        <ChatList basePath="/chat" />
      </div>
      <div className="flex-1 min-w-0">
        <ChatConversation basePath="/chat" />
      </div>
    </div>
  );
}

export default function Chat() {
  const { user } = useStore();

  if (!user) return <Navigate to="/auth" replace={true} />;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="pt-16">
        <Routes>
          <Route index element={<ChatLayout />} />
          <Route path=":id" element={<ChatLayout />} />
        </Routes>
      </main>
    </div>
  );
}
